import { render, staticRenderFns } from "./ViewMethodOutcomes.vue?vue&type=template&id=06a1f90a"
import script from "./ViewMethodOutcomes.vue?vue&type=script&lang=js"
export * from "./ViewMethodOutcomes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports